import { environment } from '../environments/environment';

export class Constants {


    // CE y CV se consultan como E únicamente en el adaptador del backend al RUNT.
    static readonly RUNT_QUERYABLE_TYPES = ['C', 'N', 'P', 'T', 'Y', 'U', 'E', 'CE', 'CV', 'D'];
    static readonly NATIONALITY = (() => {
        switch (environment.envType) {
            case 'yumbo':
                return {
                    COUNTRY_ID: "57",       // Colombia
                    DEPARTMENT_ID: '76',    // Valle del Cauca
                    CITY_ID: '76892000'     // Yumbo
                };

            case 'ipiales':
                return {
                    COUNTRY_ID: "57",       // Colombia
                    DEPARTMENT_ID: '52',    // Nariño
                    CITY_ID: '52356000'     // Ipiales
                };

            default:
                // entorno por defecto (producción)
                return {
                    COUNTRY_ID: "57",
                    DEPARTMENT_ID: '76',
                    CITY_ID: '76892000'     // Yumbo por defecto
                };
        }
    })();
    static readonly EMPTY_STRING = '';
    static readonly DEFAULT_TRACK = 'AV';
    static readonly DEFAULT_TRACK_2 = 'CL';
    static readonly DEFAULT_OFFENDER_TYPE = 1301;
    static readonly DEFAULT_ZERO = 0;
    static readonly CODE_FLOW_INFRACTION = 'traffic-infraction';
    static readonly CODE_FLOW_INFRACTION_SERVICE = 'public-traffic-infraction';
    static readonly CODE_FLOW_IPAT = 'ipat';
    static readonly IPAT_STEPS = 'ipat-steps';
    static readonly SMV_2026 = 12110;
    static readonly FORMS = {
        LOCATION: '1',
        INFO_INFRACTION: '2',
        INFO_VEHICLE: '3',
        INFO_PROPERTY_PERSON: '4',
        INFO_PROPERTY_COMPANY: '5',
        INFO_PROPERTY_COMPANY_TRANSPORT: '6',
        INFO_OFFENDER: '7',
        INFO_OFFENDER_LICENSE: '8',
        OBSERVATIONS: '9',
        INFO_WITNESS: '10',
        EVIDENCE: '11',
        FIRMS: '12',
        MENU_IPAT: '13',
        TRAFFIC_AUTHORITY: '14',
        ACCIDENT_TYPE: '15',
        LOCATION_CHARACTERISTICS: '16',
        ROADWAY_CHARACTERISTICS: '17',
        DRIVERS_VEHICLES_OWNERS: '18',
        INFO_DRIVERS: '19',
        VICTIMS_PASSENGERS_OCUPPANTS_PEDESTRIANS: '20',
        PASSENGERS: '21',
        OCUPPANTS: '22',
        PEDESTRIANS: '23',
        ACCIDENT_HYPOTHESIS: '24',
        INFO_WITNESSES: '25',
        OBSERVATIONS_IPAT: '26',
        INVOLVED_OFFICERS: '27',
        TOPOGRAPHIC_SKETCH: '28',
        INFORMATION_QUERY: 'information-query',
        TRAFFIC_INFRACTION_QUERY: 'traffic-infraction-query',
        FILES_ATTATCHMENTS: 'files-attatchments'



    }
}
